module.exports = __webpack_public_path__ + "static/media/19ESCAP15.dd9f2490.jpg";